<!DOCTYPE html>
<!--Start gursewak's Code date: 19-03-2023 : switch-express-modal  -->
<img
  src="../../../assets/icon/iclose.svg"
  mat-dialog-close
  class="close md-none"
  alt=""
/>
<div class="modal-container">
  <img
    src="../../../assets/icon/iclose.svg"
    mat-dialog-close
    class="close xs-none"
    alt=""
  />
  <div class="modal-content">
    <div class="modal-header">
      <img src="../../../assets/icon/thumb-ico.svg" class="image-ico" alt="" />
      <h2>Thank you</h2>
      <p>
        <span> We will review this within 5 days. </span>
        Use express verification if you would like your free lines now &amp;
        access to bonus offer
      </p>
    </div>
    <ion-button class="update-btn" (click)="updateBtn('express')"
      >Switch to express</ion-button
    >
    <p class="dismiss-btn" mat-dialog-close (click)="goToOfferPage()">
      Dismiss
    </p>
  </div>
</div>
<!--End gursewak's Code date: 19-03-2023 : switch-express-modal  -->
